import React, { useCallback } from 'react';
import { SearchNoResultsProps } from './../../../types/search';
import DOMPurify from 'dompurify';
import { Button } from 'react-aria-components';
import eventBus, { CUSTOM_EVENTS } from '../../utils/EventBus';
import { useSearchConfig } from '../hooks/useSearchConfig';

const SearchNoResults = ({
  noResultsText,
  clearAllFilters: _clearAllFilters,
  updateSearchTerm: _updateSearchTerm,
  variant = 'search',
}: SearchNoResultsProps) => {
  const { labels } = useSearchConfig();

  const handleClick = useCallback(() => {
    eventBus.emit(CUSTOM_EVENTS.PORTAL_CLEAR_FILTERS_AND_SEARCH);
  }, []);

  // Determine title and description based on variant
  const getTitle = () => {
    switch (variant) {
      case 'date':
        return labels.dateNoResultsTitleLabel;
      case 'filter':
        return labels.filterNoResultsTitleLabel;
      default:
        return labels.noResultsTitleLabel;
    }
  };

  const getDescription = () => {
    switch (variant) {
      case 'date':
        return labels.dateNoResultsDescriptionLabel;
      case 'filter':
        return labels.filterNoResultsDescriptionLabel;
      default:
        return noResultsText || labels.noResultsDescriptionLabel;
    }
  };

  // Date variant doesn't show CTA
  const showCta = variant !== 'date';

  const description = getDescription()?.replaceAll('\n', '<br />') ?? '';

  return (
    <div className="search-no-results">
      <div>
        <h2 className="search-no-results__title">{getTitle()}</h2>
        <div
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(
              description?.replaceAll(/ data-teams="[^"]*"/g, '').replaceAll('%20', ' ') ?? ''
            ),
          }}
        />
      </div>
      {showCta && (
        <Button className="cta cta--primary cta--small" onClick={handleClick}>
          {labels.noResultsCtaLabel}
          <svg className="portal-search-bar__icon-arrow" aria-hidden="true">
            <use href="/dist/assets/icons/sprite.svg#arrow-right-medium-portal"></use>
          </svg>
        </Button>
      )}
    </div>
  );
};

export default SearchNoResults;
